import React from "react";
import Button from '@mui/material/Button';
import { ValidateTankAdminFuncInput } from "./ValidateTankAdminFuncInput";

const btnsArray = [{ operation: "Delete" }, { operation: "Cancel" }];

export default function OverviewButtons({
  tank,
  navigate,
  _tankExist,
  _createErrorMessage,
  _deleteTank,
}) {
  const onClick = (operation) => {
    if (operation === "Cancel") {
      let navigationNextUrl = `/TankOverview`;
      navigate(navigationNextUrl);
      return;
    }

    let validationTankResult = ValidateTankAdminFuncInput(
      tank,
      _createErrorMessage
    );

    if (!validationTankResult) {
      return;
    }

    _tankExist({ data: { Id: tank } }, ({ data: isExist }) => {
      if (!isExist) {
        _createErrorMessage("55");
        return;
      }
      _deleteTank({ data: { Id: tank } });
    });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
      }}
      className="customButton"
    >
      {btnsArray.map(({ operation, noValidation, navPath }, i) => (
        <div style={{ width: "48%", marginBottom: 15 }}>
          <Button
            className="btn btn-primary w-100"
            key={operation}
            onClick={() => onClick(operation, noValidation, navPath)}
          >
            {operation}
          </Button>
        </div>
      ))}
    </div>
  );
}
